<template>
  <div class="row csat--metrics-container">
    <csat-metric-card
      :label="$t('BOT_AUTOMATION_REPORTS.METRIC.TOTAL_RESPONSES.LABEL')"
      :info-text="$t('BOT_AUTOMATION_REPORTS.METRIC.TOTAL_RESPONSES.TOOLTIP')"
      :value="conversationCount"
    />
    <csat-metric-card
      :label="$t('BOT_AUTOMATION_REPORTS.METRIC.SATISFACTION_SCORE.LABEL')"
      :info-text="
        $t('BOT_AUTOMATION_REPORTS.METRIC.SATISFACTION_SCORE.TOOLTIP')
      "
      :value="formatToPercent(this.botAutomationSummary.automation_rate)"
    />
    <csat-metric-card
      :label="$t('BOT_AUTOMATION_REPORTS.METRIC.RESPONSE_RATE.LABEL')"
      :info-text="$t('BOT_AUTOMATION_REPORTS.METRIC.RESPONSE_RATE.TOOLTIP')"
      :value="formatToPercent(this.botAutomationSummary.deflection_rate)"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CsatMetricCard from './CsatMetricCard';
import { CSAT_RATINGS } from 'shared/constants/messages';

export default {
  name: 'BotAutomationMetrics',
  components: {
    CsatMetricCard,
  },
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      csatRatings: CSAT_RATINGS,
    };
  },
  computed: {
    ...mapGetters({
      botAutomationSummary: 'getBotAutomationSummary',
    }),
    conversationCount() {
      return this.botAutomationSummary.conversations_count
        ? this.botAutomationSummary.conversations_count
        : '--';
    },
  },
  methods: {
    formatToPercent(value) {
      return value ? (Math.round(value * 100) + '%') : '--';
    },
  },
};
</script>
<style lang="scss" scoped>
.csat--metrics-container {
  background: var(--white);
  margin-bottom: var(--space-two);
  border-radius: var(--border-radius-normal);
  border: 1px solid var(--color-border);
  padding: var(--space-normal);
}

.emoji--distribution {
  display: flex;
  justify-content: flex-end;

  .emoji--distribution-item {
    padding-left: var(--space-normal);
  }
}

.emoji--distribution-chart {
  margin-top: var(--space-small);
}

.emoji--distribution-key {
  margin: 0 var(--space-micro);
}
</style>
